import React, { createContext, useContext, useState, useCallback } from "react";
import { translations, cuisineLabels } from "@/lib/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("ce_lang") || "en");

  const changeLang = useCallback((newLang) => {
    setLang(newLang);
    localStorage.setItem("ce_lang", newLang);
  }, []);

  const t = useCallback((key) => (translations[lang] && translations[lang][key]) || key, [lang]);
  const cuisineLabel = useCallback((key) => (cuisineLabels[lang] && cuisineLabels[lang][key]) || key, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, t, cuisineLabel }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
